import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
    },
    {
        path: 'select-site',
        loadChildren: () => import('./pages/select-site/select-site.module').then(m => m.SelectSitePageModule)
    },
    {
        path: 'stock-modal',
        loadChildren: () => import('./pages/stock-modal/stock-modal.module').then(m => m.StockModalPageModule)
    },
    {
        path: 'modal-result-search',
        loadChildren: () => import('./pages/modal-result-search/modal-result-search.module').then(m => m.ModalResultSearchPageModule)
    },
    {
        path: 'colisage-specifique',
        loadChildren: () => import('./pages/colisage-specifique/colisage-specifique.module').then(m => m.ColisageSpecifiquePageModule)
    },
    {
        path: 'reappro',
        loadChildren: () => import('./pages/reappro/reappro.module').then(m => m.ReapproPageModule)
    },
    {
        path: 'modal-message-tube',
        loadChildren: () => import('./pages/modal-message-tube/modal-message-tube.module').then(m => m.ModalMessageTubePageModule)
    },
    {
        path: 'modal-login-intermediaire',
        loadChildren: () => import('./pages/modal-login-intermediaire/modal-login-intermediaire.module').then(m => m.ModalLoginIntermediairePageModule)
    },
    {
        path: 'modal-validation-reception-tube-urgent',
        loadChildren: () => import('./pages/modal-validation-reception-tube-urgent/modal-validation-reception-tube-urgent.module').then(m => m.ModalValidationReceptionTubeUrgentPageModule)
    },
    {
        path: 'modal-choose-deliveries',
        loadChildren: () => import('./pages/modal-choose-deliveries/modal-choose-deliveries.module').then(m => m.ModalChooseDeliveriesPageModule)
    },
    {
        path: 'modal-user-contact',
        loadChildren: () => import('./pages/modal-user-contact/modal-user-contact.module').then(m => m.ModalUserContactPageModule)
    },
    {
        path: 'show-deliveries-pp',
        loadChildren: () => import('./pages/show-deliveries-pp/show-deliveries-pp.module').then(m => m.ShowDeliveriesPPPageModule)
    },
    {
        path: 'modal-rempotage',
        loadChildren: () => import('./pages/modal-rempotage/modal-rempotage.module').then(m => m.ModalRempotagePageModule)
    },
    {
        path: 'internal-transport',
        loadChildren: () => import('./pages/internal-transport/internal-transport.module').then(m => m.InternalTransportPageModule)
    },
    {
        path: 'modal-reconstruct-container',
        loadChildren: () => import('./pages/modal-reconstruct-container/modal-reconstruct-container.module').then(m => m.ModalReconstructContainerPageModule)
    },
    {
        path: 'modal-search-partner',
        loadChildren: () => import('./pages/modal-search-partner/modal-search-partner.module').then(m => m.ModalSearchPartnerPageModule)
    },
    {
        path: 'site-selector-custom',
        loadChildren: () => import('./pages/site-selector-custom/site-selector-custom.module').then(m => m.SiteSelectorCustomPageModule)
    },
    {
        path: 'dashboard2024',
        loadChildren: () => import('./pages/dashboard2024/dashboard2024.module').then(m => m.Dashboard2024PageModule)
    },
    {
        path: 'modal-day-checkpoints',
        loadChildren: () => import('./pages/modal-day-checkpoints/modal-day-checkpoints.module').then(m => m.ModalDayCheckpointsPageModule)
    },
    {
        path: 'product-view',
        loadChildren: () => import('./pages/product-view/product-view.module').then(m => m.ProductViewPageModule)
    },
    {
        path: 'colisage2',
        loadChildren: () => import('./pages/colisage2/colisage2.module').then(m => m.Colisage2PageModule)
    },
    {
        path: 'reception2',
        loadChildren: () => import('./pages/reception2/reception2.module').then(m => m.Reception2PageModule)
    },
    {
        path: 'recherche',
        loadChildren: () => import('./pages/recherche/recherche.module').then(m => m.RecherchePageModule)
    },
    {
        path: 'laboratory-selector',
        loadChildren: () => import('./pages/laboratory-selector/laboratory-selector.module').then(m => m.LaboratorySelectorPageModule)
    },
    {
        path: 'modal-delivery-details',
        loadChildren: () => import('./pages/modal-delivery-details/modal-delivery-details.module').then(m => m.ModalDeliveryDetailsPageModule)
    },
    {
        path: 'login-intermed',
        loadChildren: () => import('./pages/login-intermed/login-intermed.module').then(m => m.LoginIntermedPageModule)
    },
    {
        path: 'site-activity',
        loadChildren: () => import('./pages/site-activity/site-activity.module').then(m => m.SiteActivityPageModule)
    },
    {
        path: 'modal-container-multiselect',
        loadChildren: () => import('./pages/modal-container-multiselect/modal-container-multiselect.module').then(m => m.ModalContainerMultiselectPageModule)
    },
    {
        path: 'modal-tube-search-result',
        loadChildren: () => import('./pages/modal-tube-search-result/modal-tube-search-result.module').then(m => m.ModalTubeSearchResultPageModule)
    },
    {
        path: 're-do-ide-box',
        loadChildren: () => import('./pages/re-do-ide-box/re-do-ide-box.module').then(m => m.ReDoIdeBoxPageModule)
    },
    {
        path: 'modal-close-delivery-manually',
        loadChildren: () => import('./pages/modal-close-delivery-manually/modal-close-delivery-manually.module').then(m => m.ModalCloseDeliveryManuallyPageModule)
    },
    {
        path: 'login2',
        loadChildren: () => import('./pages/login2/login2.module').then(m => m.Login2PageModule)
    },
    {
        path: 'analysis-rule-manager',
        loadChildren: () => import('./pages/analysis-rule-manager/analysis-rule-manager.module').then(m => m.AnalysisRuleManagerPageModule)
    },
    {
        path: 'analysis-specific-rule-manager',
        loadChildren: () => import('./pages/analysis-specific-rule-manager/analysis-specific-rule-manager.module').then(m => m.AnalysisSpecificRuleManagerPageModule)
    },
    {
        path: 'analysis-origin-rule-manager',
        loadChildren: () => import('./pages/analysis-origin-rule-manager/analysis-origin-rule-manager.module').then(m => m.AnalysisOriginRuleManagerPageModule)
    },
    {
        path: 'analysis-site-available-manager',
        loadChildren: () => import('./pages/analysis-site-available-manager/analysis-site-available-manager.module').then(m => m.AnalysisSiteAvailableManagerPageModule)
    },
    {
        path: 'analysis-in-progress',
        loadChildren: () => import('./pages/analysis-in-progress/analysis-in-progress.module').then(m => m.AnalysisInProgressPageModule)
    },
    {
        path: 'id-card-maker',
        loadChildren: () => import('./pages/id-card-maker/id-card-maker.module').then(m => m.IdCardMakerPageModule)
    },
    {
        path: 'user-manager',
        loadChildren: () => import('./pages/user-manager/user-manager.module').then(m => m.UserManagerPageModule)
    },
    {
        path: 'user-form',
        loadChildren: () => import('./pages/user-form/user-form.module').then(m => m.UserFormPageModule)
    },
    {
        path: 'user-form/:id',
        loadChildren: () => import('./pages/user-form/user-form.module').then(m => m.UserFormPageModule)
    },
  {
    path: 'user-profil',
    loadChildren: () => import('./pages/user-profil/user-profil.module').then( m => m.UserProfilPageModule)
  },
  {
    path: 'rempotage',
    loadChildren: () => import('./pages/rempotage/rempotage.module').then(m => m.RempotageePageModule)
  },
  {
    path: 're-add-product',
    loadChildren: () => import('./pages/re-add-product/re-add-product.module').then(m => m.ReAddProductPageModule)
  },

];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
